import Vue from "vue";

import Dialog from "vuejs-dialog";
import Notifications from "vue-notification";

Vue.use(Dialog, {
    animation: "fade",
    html: true,
});
Vue.use(Notifications);

import EntryRoot from "./components/entry/entry-root.vue";
import EndpointRoot from "./components/endpoint/endpoint-root.vue";
import AccountRoot from "./components/account/account-root.vue";

Vue.component("entry-root", EntryRoot);
Vue.component("account-root", AccountRoot);
Vue.component("endpoint-root", EndpointRoot);

import store from "./store";
import { clear } from "../services/local-storage";
import API from "../api";
new Vue({
    el: "#app",
    store,
    created() {
        this.$root.$on("clear-storage", clear);
        this.$root.$on("create-project", this.createProject);
        this.$root.$on("create-form", this.createForm);
        this.$root.$on("delete-form", this.deleteForm);
        this.$root.$on("export-submissions", this.exportSubmissions);
    },
    methods: {
        createForm(payload) {
            this.$dialog
                .prompt(
                    {
                        title: `Create form for project ${payload.projectName}`,
                    },
                    {
                        promptHelp:
                            'Type form name in the box below and click "[+:okText]"',
                    }
                )
                .then(async (dialog) => {
                    try {
                        const response = await API.forms.create({
                            projectId: payload.project.id,
                            name: dialog.data,
                        });
                        if (!response.error) {
                            this.$root.$emit("update-projects");
                        }
                    } catch (err) {
                        console.error(err);
                    }
                });
        },
        deleteForm({ endpoint }) {
            this.$dialog
                .confirm(
                    `Are you sure you want to delete <strong>${endpoint.form_name}</strong>?`,
                    {
                        loader: true,
                    }
                )
                .then(async (dialog) => {
                    this.inLoading = true;
                    try {
                        await API.forms.remove({
                            projectId: endpoint.project_id,
                            endpointId: endpoint.id,
                        });
                        dialog.close();
                        window.location.reload();
                    } catch (err) {
                        console.error(err);
                    } finally {
                        this.inLoading = false;
                    }
                });
        },
        async exportSubmissions(data) {
            this.$dialog
                .confirm(
                    `<p><strong>Export Submissions?</strong><br><hr>Date: ${data.date}<br><hr>Project: ${data.project.name}<br><hr>Form: ${data.endpoint.form_name}</p>`,
                    {
                        loader: true,
                    }
                )
                .then(async (dialog) => {
                    this.inLoading = true;
                    try {
                        const response = await API.forms.exportSubmissions({
                            projectId: data.project.id,
                            endpointId: data.endpoint.id,
                            date: data.date,
                        });
                        const downloadLink = document.createElement("a");
                        downloadLink.href = URL.createObjectURL(
                            new Blob([response])
                        );
                        downloadLink.download = "export.csv";
                        document.body.appendChild(downloadLink);
                        downloadLink.click();
                        document.body.removeChild(downloadLink);
                        dialog.close();
                    } catch (err) {
                        console.error(err);
                    } finally {
                        this.inLoading = false;
                    }
                });
        },
        createProject() {
            this.$dialog
                .prompt(
                    {
                        title: "Create project",
                    },
                    {
                        promptHelp:
                            'Type project name in the box below and click "[+:okText]"',
                    }
                )
                .then(async (dialog) => {
                    try {
                        const response = await API.projects.create(dialog.data);
                        if (!response.error) {
                            this.$emit("update-projects");
                        }
                    } catch (err) {
                        console.error(err);
                    }
                });
        },
    },
});
